import React, { useState } from 'react';
import Filter from 'saur_ui_library/src/Molecules/Filter/Filter';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import { createGlobalStyle } from 'styled-components';
import TableMonitoring from '../components/module/table/TableMonitoring';
import ApiStatus from '../components/common/ApiStatus';
import { StyledSectionButton } from './H2SParam/h2sStyle';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { useDispatch } from 'react-redux';
import { ExportApi } from '../utils/api';
import { SET_JOBSLAUNCH } from '../redux/actionType';
import { LocalStorage } from '../utils/localStorage';
import { Toast } from 'primereact/toast';
import ResetStyleComponent from '../components/cssSaur/resetStyleComponent';

const MonitoringView = () => {
  const roles = LocalStorage.userRole.get();

  const [showIndic, setShowIndic] = useState(true);
  const [showApi, setShowApi] = useState(false);
  const classnameIndic = `${
    showIndic ? 'indicContainer' : 'hide-indicContainer'
  }`;
  const classnameApi = `${showApi ? 'apiContainer' : 'hide-apiContainer'}`;

  const toastInfo = React.useRef<any>(null);
  const dispatch = useDispatch();

  const calculateInstallJobs = async () => {
    try {
      await ExportApi.exportConfiguredPoolsAndBlackInstallations().then((value: any) => {
        if (value.status === 200) {
          const { runId, numberInJob } = value?.data;
          toastInfo.current?.show({
            severity: 'info',
            summary: 'Lancement du téléchargement',
            detail:
              " Votre demande est bien prise en compte. Vous pourrez télécharger dans l'onglet partage dans quelques minutes ",
            life: 15000,
          });
          dispatch({
            type: SET_JOBSLAUNCH,
            payload: {
              jobId: runId,
              runId: runId,
              isDatabricksJob: true
            },
          });
        }
      });
    } catch (e) {
      toastInfo.current?.show({
        severity: 'error',
        summary: 'Téléchargement échoué ',
        detail:
          ' Nous avons rencontré un soucis dans la prise en compte de votre demande. Veuillez réessayer ou contacter votre administrateur',
        life: 15000,
      });
    }
  };

  return (
    <Container className='sds-reset-style monitoring-page' automatedTestId='monitoring-page'>
      <ResetStyleComponent />
      <Styles />
      <Toast id='toast-info' ref={toastInfo} />
      <Container className='monitoring-filter'>
        <Filter
          className='filterSelect'
          startSelected={1}
          buttons={[
            {
              id: 1,
              value: 'Indicateur',
              automatedTestId: 'select-indic',
              onClick: () => {
                setShowIndic(true);
                setShowApi(false);
              },
            },
            {
              id: 2,
              value: 'API',
              automatedTestId: 'select-api',
              onClick: () => {
                setShowIndic(false);
                setShowApi(true);
              },
            },
          ]}
        />
        {roles?.includes('diagperm-admin') && <Container className='export-button'>
          <StyledSectionButton>
            <Button
              className='export-btn'
              mode='plain'
              onClick={() => {
                calculateInstallJobs();
              }}
            >
              <Word variant='span' textStyle='normalBold' value='Export ECP' />
            </Button>
          </StyledSectionButton>
        </Container>}
      </Container>
      {showIndic ? (
        <Container className={classnameIndic}>
          <TableMonitoring />
        </Container>
      ) : null}
      {showApi ? (
        <Container className={classnameApi}>
          <ApiStatus />
        </Container>
      ) : null}
    </Container>
  );
};

const Styles = createGlobalStyle`
 .monitoring-page{
    margin-left: auto;
    width: 80vw;
  .api-card {
   margin-top: 10px;
  };
  .filterSelect{
    width:30%;
    margin-bottom: 15px;
  }
  .hide-indicContainer,.hide-apiContainer{
    display:none
  }
  .monitoring-filter{
    flex-direction: row !important;
    justify-content: space-between;
    width: 50%;
    margin-top: 20px;
  }
  .export-button{
    margin-left: 80px;
    margin-bottom: 15px;
    width: 30%;
  }
} `;

export default MonitoringView;
